import { createSlice } from '@reduxjs/toolkit';

// Define a slice using createSlice
const userSlice = createSlice({
    name: 'user',
    initialState: { allUsers: [], user: null, emailId: '' },
    reducers: {
      setAllUsers: (state, action) => {
        state.allUsers = action.payload;
      },
      setCurrentUser: (state, action) => {
        state.user = action.payload;
      },
      setEmailId: (state, action) => {
        state.emailId = action.payload
      },
    },
  });

  // Export the action creator functions
export const { setAllUsers, setCurrentUser, setEmailId } = userSlice.actions;
export default userSlice